import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/Auth';
import { Loader } from '@mantine/core';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean; // If false, redirects authenticated users away
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #0a0a23 0%, #1a1a2e 50%, #16213e 100%)'
      }}>
        <Loader size="xl" color="blue" />
      </div>
    );
  }

  if (requireAuth) {
    // Route requires authentication
    if (!isAuthenticated) {
      // Redirect to login page with return URL
      return <Navigate to="/login-page" state={{ from: location }} replace />;
    }
  } else {
    // Route is for non-authenticated users (like login page, public landing)
    if (isAuthenticated) {
      // If user has no_plan, redirect to pricing instead of home
      if (user?.plan === 'no_plan') {
        return <Navigate to="/pricing" replace />;
      }
      // Redirect other authenticated users to main app dashboard
      return <Navigate to="/home" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
